// extracted by mini-css-extract-plugin
export default {"select-url-option__page-label":"select-url-option__page-label-jPNuQ","select-url-option__url":"select-url-option__url-crmKV"};